import { request } from '@/shared/api/request'

export const deleteXml = (externalId) => {
	return request({ url: 'contract/deletion/' + externalId + '/xml', method: 'GET' })
}

export const deleteExternalXml = (data) => {
	return request({ url: 'contract/deletion/xml', method: 'POST', data: data })
}
